const RESHOW_AFTER_MS = 14 * 24 * 60 * 60 * 1000;

export type PwaOnboardingStep = "install" | "push_primer";

function key(step: PwaOnboardingStep): string {
  return `pwa-onboarding-dismissed-${step}`;
}

export function wasRecentlyDismissed(step: PwaOnboardingStep): boolean {
  try {
    const raw = window.localStorage.getItem(key(step));
    if (!raw) return false;
    const dismissedAt = Number(raw);
    return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < RESHOW_AFTER_MS;
  } catch {
    return false;
  }
}

export function markDismissed(step: PwaOnboardingStep): void {
  try {
    window.localStorage.setItem(key(step), String(Date.now()));
  } catch {
    // Private-browsing / quota — the modal just shows again next load, not worth surfacing.
  }
}
